<template>
  <div v-bind="$attrs">
    <v-avatar
      ref="avatar"
      :color="color"
      :icon="icon"
      :image="img"
      size="32"
      class="rounded"
      data-testid="so-avatar"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { StatusType } from "@/types/Status"
  import { Utility } from "@/types/Utility"
  import logo from "@/assets/SOE_logo_avatar.svg"

  export type AvatarTypes =
    "soenergy" | "electric" | "gas" | "ihd" | StatusType | Utility

  export default defineComponent({
    inheritAttrs: false,
    props: {
      type: {
        type: String as PropType<AvatarTypes>,
        default: "",
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      color() {
        if (this.disabled) {
          return "default"
        }
        if ((Object.values(Utility) as string[]).includes(this.type)) {
          return this.type
        }

        switch (this.type) {
          case "soenergy":
            return "black"
          case "electric":
            return "electric"
          case "gas":
            return "gas"
          case "ihd":
            return "ihd"
          case "appointment":
            return "appointment"
          case "normal":
            return "normal"
          case "caution":
            return "caution"
          case "critical":
            return "critical"
          case "neutral":
            return "neutral"
          case "default":
            return "default"
          default:
            return "primary"
        }
      },
      icon() {
        switch (this.type) {
          case "soenergy":
            return ""
          case "electric":
            return "electric"
          case "gas":
            return "gas"
          case "ihd":
            return "tablet"
          case "appointment":
            return "wrench"
          case Utility.Communication:
            return "email"
          case Utility.Complaint:
            return "alert-circle"
          case Utility.Note:
            return "square-edit"
          case Utility.Freshdesk:
            return "message-processing"
          case Utility.Junifer:
            return "list"
          case Utility.Bill:
            return "file"
          case Utility.Payment:
            return "wallet"
          case Utility.Case:
            return "briefcase"
          case Utility.Other:
            return "file"
          default:
            return "user"
        }
      },
      img() {
        switch (this.type) {
          case "soenergy":
            return logo
          default:
            return ""
        }
      },
    },
  })
</script>
